import ProductBrandCrud from "../components/product-brand/ProductBrandCrud";

const ProductBrandCrudPage = () => {
  return (
    <>
      <ProductBrandCrud />
    </>
  );
};

export default ProductBrandCrudPage;
